/**
 * Reveal Google Reviews (Entangle) when ready, then theme-match layout + mobile slides.
 */
(function () {
  if (window.__grpReviewsDeferInit) return;
  window.__grpReviewsDeferInit = true;

  var TIMEOUT_MS = 8000;
  var POLL_MS = 100;
  var GAP_FALLBACK = 16;
  var startedAt = Date.now();

  function reveal(root) {
    if (!root || root.classList.contains('grp-reviews-ready')) return;
    root.classList.add('grp-reviews-ready');
    var section = root.closest('.shopify-section');
    if (section) section.classList.add('grp-reviews-ready');
  }

  function isReady(root) {
    if (!root) return false;
    if (root.getAttribute('data-grp-initialized') === 'true') {
      var items = root.querySelectorAll('.grp-entangle-item, .grp-slider-slide, .grp-entangle-badge');
      if (items.length > 0) return true;
    }
    var slider = root.querySelector('[id^="new-rocket-slider-"]');
    if (slider && slider.querySelector('.grp-slider-slide, .grp-entangle-item')) {
      return true;
    }
    return false;
  }

  function slidesPerView() {
    var w = window.innerWidth || document.documentElement.clientWidth;
    if (w < 750) return 1;
    if (w < 1150) return 2;
    return 3;
  }

  function trackGap(track) {
    if (!window.getComputedStyle || !track) return GAP_FALLBACK;
    var g = window.getComputedStyle(track).gap || window.getComputedStyle(track).columnGap;
    var parsed = parseFloat(g);
    return isNaN(parsed) ? GAP_FALLBACK : parsed;
  }

  function getSliderParts(root) {
    var slider = root.querySelector('[id^="new-rocket-slider-"]');
    if (!slider) return null;
    var track = slider.querySelector('.slider-track');
    var slides = slider.querySelectorAll('.grp-slider-slide');
    if (!track || !slides.length) return null;
    return { slider: slider, track: track, slides: slides };
  }

  function applySlideLayout(root) {
    var parts = getSliderParts(root);
    if (!parts) return;

    var n = slidesPerView();
    parts.slider.setAttribute('data-slides-per-view', String(n));

    var available = parts.slider.clientWidth;
    if (!available || available < 40) return;

    var gap = trackGap(parts.track);
    var slideWidth = Math.floor((available - gap * Math.max(n - 1, 0)) / n);
    if (slideWidth < 120) slideWidth = Math.max(120, available - gap);

    parts.slides.forEach(function (slide) {
      slide.style.setProperty('flex', '0 0 ' + slideWidth + 'px', 'important');
      slide.style.setProperty('width', slideWidth + 'px', 'important');
      slide.style.setProperty('max-width', slideWidth + 'px', 'important');
      slide.style.setProperty('min-width', '0', 'important');
      slide.style.setProperty('transform', 'none', 'important');
    });

    var maxCard = 0;
    parts.slides.forEach(function (slide) {
      var item = slide.querySelector('.grp-entangle-item');
      var h = (item || slide).offsetHeight || 0;
      if (h > maxCard) maxCard = h;
    });
    if (maxCard > 0) {
      parts.slider.style.setProperty('height', 'auto', 'important');
      parts.slider.style.setProperty('min-height', maxCard + 'px', 'important');
    }

    var state = root.__grpNav || { index: 0 };
    var maxIndex = Math.max(0, parts.slides.length - n);
    if (state.index > maxIndex) state.index = maxIndex;
    root.__grpNav = state;
    goTo(root, state.index, false);
    syncPagination(root);
  }

  function goTo(root, index, animate) {
    var parts = getSliderParts(root);
    if (!parts) return;

    var n = slidesPerView();
    var maxIndex = Math.max(0, parts.slides.length - n);
    index = Math.max(0, Math.min(index, maxIndex));

    var gap = trackGap(parts.track);
    var slideWidth = parts.slides[0].getBoundingClientRect().width;
    var offset = index * (slideWidth + gap);

    parts.track.style.setProperty('transition-property', 'transform', 'important');
    parts.track.style.setProperty(
      'transition-duration',
      animate === false ? '0s' : '0.55s',
      'important'
    );
    parts.track.style.setProperty('transition-timing-function', 'ease', 'important');
    parts.track.style.setProperty('transform', 'translateX(-' + offset + 'px)', 'important');

    root.__grpNav = { index: index };
    syncPagination(root);
  }

  function syncPagination(root) {
    var state = root.__grpNav || { index: 0 };
    var pager = root.querySelector('.grp-slider-pagination-wrapper, .slider-pagination');
    if (!pager) return;
    var buttons = pager.querySelectorAll('button');
    if (!buttons.length) return;

    var n = slidesPerView();
    var parts = getSliderParts(root);
    var maxIndex = parts ? Math.max(0, parts.slides.length - n) : buttons.length - 1;

    buttons.forEach(function (btn, i) {
      var active = i === state.index;
      var beyond = i > maxIndex;
      btn.style.setProperty('display', beyond ? 'none' : 'inline-block', 'important');
      if (beyond) return;
      btn.style.setProperty('width', active ? '2.8rem' : '0.8rem', 'important');
      btn.style.setProperty('height', active ? '0.6rem' : '0.8rem', 'important');
      btn.style.setProperty(
        'background',
        active ? 'rgb(var(--color-accent, 254, 205, 26))' : 'rgba(0,0,0,0.2)',
        'important'
      );
      btn.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function wireNav(root) {
    if (root.dataset.grpNavWired === '1') return;
    root.dataset.grpNavWired = '1';
    root.__grpNav = { index: 0 };

    var prev = root.querySelector('[class*="grp-slider-prev"]');
    var next = root.querySelector('[class*="grp-slider-next"]');

    function onPrev(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var i = (root.__grpNav && root.__grpNav.index) || 0;
      goTo(root, i - 1, true);
      if (prev && prev.blur) prev.blur();
    }

    function onNext(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var i = (root.__grpNav && root.__grpNav.index) || 0;
      goTo(root, i + 1, true);
      if (next && next.blur) next.blur();
    }

    if (prev) prev.addEventListener('click', onPrev, true);
    if (next) next.addEventListener('click', onNext, true);

    var pager = root.querySelector('.grp-slider-pagination-wrapper, .slider-pagination');
    if (pager) {
      pager.addEventListener(
        'click',
        function (e) {
          var btn = e.target.closest('button');
          if (!btn || !pager.contains(btn)) return;
          var buttons = Array.prototype.slice.call(pager.querySelectorAll('button'));
          var idx = buttons.indexOf(btn);
          if (idx < 0) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          goTo(root, idx, true);
        },
        true
      );
    }

    var parts = getSliderParts(root);
    if (parts) {
      var startX = 0;
      var dragging = false;
      parts.slider.addEventListener(
        'touchstart',
        function (e) {
          if (!e.touches || !e.touches[0]) return;
          startX = e.touches[0].clientX;
          dragging = true;
        },
        { passive: true }
      );
      parts.slider.addEventListener(
        'touchend',
        function (e) {
          if (!dragging || !e.changedTouches || !e.changedTouches[0]) return;
          dragging = false;
          var dx = e.changedTouches[0].clientX - startX;
          var i = (root.__grpNav && root.__grpNav.index) || 0;
          if (Math.abs(dx) < 40) return;
          goTo(root, dx < 0 ? i + 1 : i - 1, true);
        },
        { passive: true }
      );
    }
  }

  function enhance(root) {
    reveal(root);
    wireNav(root);
    applySlideLayout(root);
  }

  function layoutAll() {
    document.querySelectorAll('.grp-entangle--root.grp-reviews-ready').forEach(applySlideLayout);
  }

  function scan() {
    var roots = document.querySelectorAll('.grp-entangle--root');
    var allReady = roots.length > 0;
    roots.forEach(function (root) {
      if (isReady(root)) {
        enhance(root);
      } else {
        allReady = false;
      }
    });
    return allReady && roots.length > 0;
  }

  function tick() {
    if (scan()) return true;
    if (Date.now() - startedAt > TIMEOUT_MS) {
      document.querySelectorAll('.grp-entangle--root').forEach(enhance);
      return true;
    }
    return false;
  }

  function start() {
    tick();

    // Only watch review roots — observing document style/class (sticky header,
    // swipers) caused layout thrash that can freeze mobile scrolling.
    var obs = new MutationObserver(function () {
      tick();
    });
    function observeRoots() {
      document.querySelectorAll('.grp-entangle--root').forEach(function (root) {
        if (root.dataset.grpObs === '1') return;
        root.dataset.grpObs = '1';
        obs.observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-grp-initialized', 'class']
        });
      });
    }
    observeRoots();

    var timer = setInterval(function () {
      observeRoots();
      if (tick()) {
        clearInterval(timer);
        var settleUntil = Date.now() + 2500;
        var settle = setInterval(function () {
          layoutAll();
          if (Date.now() > settleUntil) {
            clearInterval(settle);
            obs.disconnect();
          }
        }, 200);
      }
    }, POLL_MS);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layoutAll, 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', function () {
    tick();
    layoutAll();
  });
})();
